import React, { useState, useEffect, useRef, useMemo } from "react";
import { Switch } from "@mui/material";
import Search from "../../assets/icons/search.svg";
import { POSITIONS_COLOR } from "../../utils/constants";
import { useDispatch, useSelector } from "react-redux";
import Pagination from "../Pagination/Pagination";
import {
    DraftSearch,
    NumWrapper,
    NumItem,
    DraftPlayerItem,
    DraftPlayers
} from "./DraftRoomComponent.styles";
import {
    getPlayersDraftRoom,
    selectPlayersDraftRoom,
    searchPlayersDraftRoom,
    pageNavDraftRoom,
    positionActionDraftRoom
} from "../../app/features/playersRoomDraft/playersRoomDraftSlice";
import { selectStimulyatorDrafRoom } from "../../app/features/stimulyatorDraftRoom/stimulyatorDraftRoomSlice";
import Spinner from "../Spinner/Spinner";

function DraftRoomPartPlayers(props) {
    const dispatch = useDispatch();
    const initial = useRef(true);
    const [searchValue, setSearchValue] = useState("");
    const { selectedPositions, position, loading, results, count, limit, currentPage, previous, next } =
        useSelector(selectPlayersDraftRoom);

    const { isPausedForUserPick, chosenPlayerIds } =
        useSelector(selectStimulyatorDrafRoom);
    const [colorShow, setColorShow] = useState(true);
    const positionsData = [
        "All Positions",
        "QB",
        "WR",
        "TE",
        "RB",
        "OT",
        "CB",
        "S",
        "DL",
        "EDGE",
        "LB",
        "iOL"
    ];

    useEffect(() => {
        dispatch(getPlayersDraftRoom());
    }, [dispatch]);

    useEffect(() => {
        if (isPausedForUserPick) {
            dispatch(getPlayersDraftRoom());
        }
    }, [dispatch, isPausedForUserPick]);

    useEffect(() => {
        const interval = setInterval(() => {
            if (!isPausedForUserPick) {
                if (position.length > 0) {
                    dispatch(positionActionDraftRoom(selectedPositions));
                } else {
                    dispatch(getPlayersDraftRoom());
                }
            }
        }, 10000);
        return () => clearInterval(interval);
    }, [dispatch, isPausedForUserPick, position, selectedPositions]);

    useEffect(() => {
        if (initial.current) {
            initial.current = false;
            return;
        }
        const timer = setTimeout(() => {
            dispatch(searchPlayersDraftRoom(searchValue));
        }, 500);
        return () => clearTimeout(timer);
    }, [searchValue, dispatch]);

    const filteredPlayers = useMemo(() => {
        return results.filter(p => !chosenPlayerIds.includes(p.id));
    }, [results, chosenPlayerIds]);

    const renderData = filteredPlayers.map((player, idx) => (
        <DraftPlayerItem
            key={player.id}
            backColor={colorShow ? POSITIONS_COLOR[player.position] : ""}
        >
            <div className="single-inside first">
                <div className="name">Rank</div>
                <div className="value">{player.ranking}</div>
            </div>
            <div className="single-inside second">
                <div className="name">BPA</div>
                <div className="value">{idx + 1}</div>
            </div>
            <div className="single-inside third">
                <div className="name">School</div>
                <div className="value">{player.school}</div>
            </div>
            <div className="value-blue">{player.player}</div>
            <div className="single-position fourth">{player.position}</div>
            <button
                onClick={() =>
                    props.onSetPickedPlayers({
                        id: player.id,
                        player: player.player,
                        position: player.position,
                        college: player.school,
                        ranking: player.ranking
                    })
                }
            >
                +
            </button>
            <button
                onClick={() =>
                    props.onAddPlayer({
                        id: player.id,
                        player: player.player,
                        position: player.position,
                        college: player.school,
                        ranking: player.ranking
                    })
                }
            >
                Draft
            </button>
        </DraftPlayerItem>
    ));

    const handlePositionClick = (pos) => {
        const IOL_GROUP = ["iOL", "iOL_C"];
        let next = [...selectedPositions];
        if (pos === "All Positions") {
            next = ["All Positions"];
        } else if (pos === "iOL") {
            const isActive = IOL_GROUP.every((p) => next.includes(p));
            next = isActive
                ? next.filter((p) => !IOL_GROUP.includes(p))
                : [...next.filter((p) => p !== "All Positions"), ...IOL_GROUP];
        } else {
            next = next.includes(pos)
                ? next.filter((p) => p !== pos)
                : [...next.filter((p) => p !== "All Positions"), pos];
        }
        if (next.length === 0) next = ["All Positions"];
        dispatch(positionActionDraftRoom(next));
    };

    return (
        <>
            <NumWrapper>
                {positionsData.map((item, idx) => {
                    const isSelected = selectedPositions.includes(item);
                    return (
                        <NumItem
                            key={idx}
                            backColor={POSITIONS_COLOR[item] || ""}
                            onClick={() => handlePositionClick(item)}
                            className={isSelected ? "active" : null}
                        >
                            <span>{item}</span>
                        </NumItem>
                    );
                })}
                <div className="switch-label">
                    Show positions colors in list
                    <Switch
                        defaultChecked
                        onChange={() => setColorShow(prev => !prev)}
                    />
                </div>
            </NumWrapper>
            <DraftSearch>
                <input
                    placeholder="Search"
                    value={searchValue}
                    onChange={e => setSearchValue(e.target.value)}
                />
                <img src={Search} alt="searchIcon" />
            </DraftSearch>
            {loading ? (
                <Spinner />
            ) : (
                <DraftPlayers>{renderData}</DraftPlayers>
            )}
            <div className="pagination-div">
                <Pagination
                    totalCount={count}
                    pageSize={limit}
                    currentPage={currentPage}
                    previous={previous}
                    next={next}
                    onPageChange={page => dispatch(pageNavDraftRoom(page))}
                />
            </div>
        </>
    );
}

export default DraftRoomPartPlayers;



